// Apolo IDE — WorkSummary (Code chat redesign v2 · Codex-rich).
//
// Collapsible header that wraps a turn's tool rows, styled after the
// "⚡ Trabalhou por 2m 49s ›" pill in _mockups/code-chat-v2/redesign.html —
// a glass pill with a blue glow, a sparkles icon, a chevron, and a
// right-aligned muted-mono "N ações" meta.
//
// Closed by default — agents fire many tools, the user usually wants the
// result, not every step — but expandable to reveal the rows (`children`).
//
//   • Header is a real <button class="rx-worksum"> (aria-expanded): a
//     .rx-spark sparkles icon + label "Trabalhou por {duração}" + chevron
//     + right-aligned .rx-meta mono "{n} ação/ações".
//   • Body renders `children` only when open (state inits from defaultOpen).
//   • Enter/Space toggle natively (it's a <button>).
//
// `fmtDuration` mirrors ToolCallBlock's logic exactly (round seconds ≥10s).

import { useState, useEffect } from 'react';
import { Sparkles, ChevronRight, ChevronDown } from 'lucide-react';
import './redesign.css';

function fmtDuration(ms) {
  if (ms == null || Number.isNaN(ms)) return null;
  if (ms < 1000) return `${ms}ms`;
  return ms < 10000 ? `${(ms / 1000).toFixed(1)}s` : `${Math.round(ms / 1000)}s`;
}

export default function WorkSummary({ durationMs, actionCount, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  // Reage se defaultOpen virar true após o mount (ex: um tool do run falha no
  // meio → o resumo deve abrir pra não esconder o erro). Não força fechar — o
  // usuário ainda pode colapsar manualmente. (CodeRabbit)
  useEffect(() => {
    if (defaultOpen) setOpen(true);
  }, [defaultOpen]);
  const duration = fmtDuration(durationMs);
  const label = duration ? `Trabalhou por ${duration}` : 'Trabalhou';

  return (
    <div className="my-2">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="rx-worksum"
      >
        <Sparkles className="rx-spark" size={13} aria-hidden="true" />
        <span className="rx-worksum-label">{label}</span>
        {open ? (
          <ChevronDown className="rx-chev" size={13} aria-hidden="true" />
        ) : (
          <ChevronRight className="rx-chev" size={13} aria-hidden="true" />
        )}
        <span className="rx-meta">
          {actionCount} {actionCount === 1 ? 'ação' : 'ações'}
        </span>
      </button>
      {open && <div className="rx-worksum-body">{children}</div>}
    </div>
  );
}
